var _filter, _g, _text, _text2, _g2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 80",
    className: "premier-choice-logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "redGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FF0404",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#E60303",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 2,
    stdDeviation: 3,
    floodColor: "rgba(255,4,4,0.3)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 15)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 23,
    fill: "url(#redGradient)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20 L20 15 L25 20 L30 15 L35 20 L35 30 Q35 35 30 35 L20 35 Q15 35 15 30 Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 25,
    r: 2,
    fill: "url(#redGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 22,
    r: 2,
    fill: "url(#redGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 25,
    r: 2,
    fill: "url(#redGradient)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 30,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: "bold",
    fill: "url(#redGradient)"
  }, "PREMIER")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 50,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#666666"
  }, "CHOICE")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(65, 55)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 5,
    x2: 15,
    y2: 5,
    stroke: "url(#redGradient)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 9,
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fontWeight: "normal",
    fill: "url(#redGradient)"
  }, "CPR"), /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 5,
    x2: 60,
    y2: 5,
    stroke: "url(#redGradient)",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 65 L75 65 L78 60 L82 70 L86 55 L90 75 L94 65 L140 65",
    stroke: "url(#redGradient)",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a5850f439c7676ee994e1e890e864d2a.svg";
export { ForwardRef as ReactComponent };